import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLeftClick = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M7.14276 14.8571V13.5714C7.14276 7.18072 12.3235 2 18.7142 2H19.9999V14.8571H7.14276Z",
			fill: "var(--icon-primary)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M32.8572 14.8571C32.8572 7.75634 27.1008 2 20 2C12.8992 2 7.14288 7.75634 7.14288 14.8571V25.1429C7.14288 32.2437 12.8992 38 20 38C27.1008 38 32.8572 32.2437 32.8572 25.1429V14.8571Z",
			fill: "none",
			stroke: "var(--icon-default)",
			strokeWidth: 2.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20 2V14.8571",
			fill: "none",
			stroke: "var(--icon-default)",
			strokeWidth: 2.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.9286 10.357C21.9286 9.29192 21.0652 8.42847 20 8.42847C18.9349 8.42847 18.0715 9.29192 18.0715 10.357V14.2142C18.0715 15.2793 18.9349 16.1428 20 16.1428C21.0652 16.1428 21.9286 15.2793 21.9286 14.2142V10.357Z",
			fill: "var(--icon-default)"
		})
	]
});
export default SvgLeftClick;
